/**
 * @generated SignedSource<<a4239f1d053a00ab5ee7c2eb0bea25c0>>
 * @relayHash 456fd8de70d686598610e497cbc7322f
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 456fd8de70d686598610e497cbc7322f

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "token"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "token",
        "variableName": "token"
      }
    ],
    "concreteType": "TokenStatusResponse",
    "kind": "LinkedField",
    "name": "buildFileStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BuildFileStatusMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BuildFileStatusMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "456fd8de70d686598610e497cbc7322f",
    "metadata": {},
    "name": "BuildFileStatusMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "16f29c2d334a6a17123b905816e936a5";

export default node;
